export default __webpack_public_path__ + "static/CircularStd-Bold-a2b7daf66e9272b95ec85a41c76a844b.ttf";